import React from "react"
import {Box, SvgIcon, Typography, useTheme} from "@mui/material"

const d = "M49.1855 0.926898L10.6921\n" +
    "                    14.4635C4.28621 16.7162 0 22.767\n" +
    "                    0 29.5574V79.4426C0 86.233 4.2862 92.2838\n" +
    "                     10.6921 94.5365L49.1855 108.073C52.7254\n" +
    "                     109.318 56.5903 109.279 60.1044 107.963L95.611\n" +
    "                      94.6669C101.86 92.327 106 86.3552 106\n" +
    "                      79.683V29.317C106 22.6447 101.86 16.673\n" +
    "                      95.611 14.3331L60.1044 1.03693C56.5903\n" +
    "                      -0.279009 52.7254 -0.317957 49.1855 0.926898Z"

const HoneyWidget = ({widget, disabled, triggerAction}) => {
    const onClick = () => widget.action && triggerAction(widget.action, widget)
    const theme = useTheme()
    return (
        <div
            className="hexagon-container"
            style={{
                position: "relative",
                width: "120px",
                height: "120px",
                cursor: disabled ? "not-allowed" : "pointer",
            }}
        >
            <SvgIcon
                className="hexagon-svg"
                htmlColor={disabled ? theme.HONEYWIDGET.disabledColor : "#fff"}
                component="svg"
                onClick={onClick}
                viewBox="-5 -5 116 119"
                sx={{
                    width: "100%",
                    height: "100%",
                    cursor: disabled ? "not-allowed" : "pointer",
                    transition: "all 0.1s ease-out",
                    "&:hover > .hexagon-border": {
                        strokeDashoffset: 0,
                    },
                }}
            >
                <path
                    className="hexagon-base"
                    d={d}
                    strokeWidth="2"
                    fill="none"
                    stroke="#ccc"
                />
                <path
                    className="hexagon-border"
                    d={d}
                    fill="none"
                    style={{transition: "stroke-dashoffset 0.7s ease-out"}}
                    stroke={theme.HONEYWIDGET.borderStrokeColor}
                    strokeWidth="3"
                    strokeDasharray={600}
                    strokeDashoffset={-600}
                />
            </SvgIcon>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    pointerEvents: "none",
                }}
            >
                <Typography textAlign="center" padding="8px">{widget.text}</Typography>
            </Box>
        </div>
    )
}

export default HoneyWidget
